import clsx from 'clsx'

import type { FC } from 'react'

type Props = {
  children: React.ReactNode
  className?: string
}

const PageRoot: FC<Props> = ({ children, className }) => {
  return (
    <section className={clsx('space-y-11 pb-8', className)}>{children}</section>
  )
}

export default PageRoot
